import { Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SettingsModel } from '../../../shared/Model/setting.model';
import { SettingService } from '../Services/aboutUs.service';
import { SlicePipe } from '@angular/common';
import { Subscription } from 'rxjs';
import { ProfilePageRoutingModule } from "../../../pages/my-account/profile-page-routing.module";
import { RouterLink } from '@angular/router';
import { SharedModule } from '../../../shared/Module/shared.module';

@Component({
  selector: 'app-footer',
  imports: [TranslateModule, SlicePipe, ProfilePageRoutingModule,RouterLink, SharedModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css'
})
export class FooterComponent {
  settings: SettingsModel[] = []
  private subs = new Subscription();   // container for all subscriptions


  private settingService = inject(SettingService)

  ngOnInit(): void {
    this.loadData();
  }

  loadData() {
    const sub = this.settingService.getAllSettings().subscribe({
      next: (data) => {
        this.settings = data.value
      },
      error: (err) => {
        console.error('Error loading About us:', err);
      }
    })
    this.subs.add(sub);
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();   // unsubscribe from all
  }
}
